module.exports = __webpack_public_path__ + "img/workflow.a8d8e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workflow.png
// module id = koDU
// module chunks = 64